import useHistoryTimeline from '../../hooks/useHistoryTimeline'
import Overview from './components/HistoryOverview'
import Item from './components/HistoryTimelineItem'

interface Props {
  simple?: boolean
  history: TopHap.PropertyTransaction[]
  limit?: number
}

export const HistoryTimelineCard: React.FC<Props> = ({ simple, history, limit }) => {
  const eventItems = useHistoryTimeline(history)
  const items = limit ? eventItems.slice(0, limit) : eventItems

  return (
    <div className='h-[18rem]'>
      {history.length > 0 && <Overview count={history.length} label='Events' />}

      {items.map((e, index) => (
        <Item
          key={index}
          date={e.date}
          description={e.title}
          simple={simple}
          type={e.type}
        />
      ))}

      <div className='pointer-events-none absolute inset-x-0 -bottom-5 h-20 w-full bg-gradient-to-t from-white via-[#fffc]' />
    </div>
  )
}

export default HistoryTimelineCard
